import { useState } from "react";
import { X, Lock, Check, AlertCircle } from "lucide-react";
import api from "../../services/api";

export default function ChangePasswordModal({ onClose }) {
  var currentState = useState("");
  var newState = useState("");
  var confirmState = useState("");
  var loadingState = useState(false);
  var errorState = useState(null);
  var successState = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    errorState[1](null);

    if (newState[0].length < 6) { errorState[1]("Nova senha deve ter no minimo 6 caracteres"); return; }
    if (newState[0] !== confirmState[0]) { errorState[1]("Senhas nao conferem"); return; }

    loadingState[1](true);
    try {
      await api.post("/auth/change-password", {
        current_password: currentState[0],
        new_password: newState[0],
      });
      successState[1](true);
    } catch(err) {
      var detail = err.response?.data?.detail || "Erro ao alterar senha";
      errorState[1](typeof detail === "string" ? detail : "Erro ao alterar senha");
    } finally { loadingState[1](false); }
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-sm" data-testid="change-password-modal">
        <div className="bg-white rounded-2xl shadow-2xl">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">Alterar Senha</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>

          {successState[0] ? (
            <div className="p-6 text-center">
              <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <Check className="w-7 h-7 text-emerald-600" />
              </div>
              <p className="text-base font-semibold text-[#0A2F3D] mb-1">Senha alterada!</p>
              <p className="text-sm text-gray-500 mb-4">Sua nova senha esta ativa.</p>
              <button onClick={onClose} className="px-6 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB]" data-testid="change-password-done">Ok</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="p-5 space-y-4">
              {errorState[0] && (
                <div className="flex items-start gap-2 px-3 py-2.5 bg-red-50 rounded-lg border border-red-100">
                  <AlertCircle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
                  <p className="text-sm text-red-600">{errorState[0]}</p>
                </div>
              )}
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Senha Atual</label>
                <div className="relative">
                  <Lock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                  <input type="password" value={currentState[0]} onChange={function(e) { currentState[1](e.target.value); }}
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                    placeholder="Sua senha atual" required data-testid="change-password-current" />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Nova Senha</label>
                <div className="relative">
                  <Lock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                  <input type="password" value={newState[0]} onChange={function(e) { newState[1](e.target.value); }}
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                    placeholder="Minimo 6 caracteres" required minLength={6} data-testid="change-password-new" />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Confirmar Nova Senha</label>
                <div className="relative">
                  <Lock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                  <input type="password" value={confirmState[0]} onChange={function(e) { confirmState[1](e.target.value); }}
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                    placeholder="Repita a nova senha" required minLength={6} data-testid="change-password-confirm" />
                </div>
              </div>
              <div className="flex gap-3 pt-1">
                <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
                <button type="submit" disabled={loadingState[0]} className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50" data-testid="change-password-submit">
                  {loadingState[0] ? "Salvando..." : "Alterar Senha"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
